export default "__VITE_ASSET__366f55c7__"